"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSinking = void 0;
const react_redux_1 = require("react-redux");
const utils_1 = require("./utils");
function createSinking(container) {
    return function (sink, subscriber = true) {
        const sinkPrototype = container.getSinkPrototype(sink);
        const namespace = sinkPrototype.namespace;
        const mapDispatch = () => ({ [namespace]: sinkPrototype.dispatches });
        let mapState;
        if (subscriber) {
            if (typeof subscriber === 'function') {
                const subscribes = subscriber(sinkPrototype.stateNames);
                mapState = (state) => ({
                    [sinkPrototype.namespace]: utils_1.reduceKeys(subscribes, key => state[sinkPrototype.namespace][key])
                });
            }
            else {
                mapState = (state) => ({ [sinkPrototype.namespace]: state[sinkPrototype.namespace] });
            }
        }
        const mergeProps = (state, dispatch, own) => (Object.assign({ [namespace]: utils_1.mergeState(state[namespace], sinkPrototype.state, dispatch[namespace]) }, own));
        return react_redux_1.connect(mapState, mapDispatch, mergeProps);
    };
}
exports.createSinking = createSinking;
